import { t } from 'i18next';

import { RefundStatus } from 'types/pwcOrder';

const STATUS_LABELS: Record<RefundStatus, [string, string]> = {
  [RefundStatus.AWAITING_FUNDS]: ['page.pwcOrders.components.status.awaitingFunds', 'Awaiting Funds'],
  [RefundStatus.INITIATED]: ['page.pwcOrders.components.status.initiated', 'Initiated'],
  [RefundStatus.PENDING]: ['page.pwcOrders.components.status.pending', 'Pending'],
  [RefundStatus.SUBMITTED]: ['page.pwcOrders.components.status.submitted', 'Submitted'],
  [RefundStatus.CONFIRMED]: ['page.pwcOrders.components.status.confirmed', 'Confirmed'],
  [RefundStatus.COMPLETED]: ['page.pwcOrders.components.status.completed', 'Completed'],
  [RefundStatus.CANCELED]: ['page.pwcOrders.components.status.canceled', 'Canceled'],
  [RefundStatus.FAILED]: ['page.pwcOrders.components.status.failed', 'Failed'],
};

export const LABELS = {
  STATUS: STATUS_LABELS,
};

export const badgePropsMap: Record<RefundStatus, { type: RefundStatus; label: string }> = {
  [RefundStatus.AWAITING_FUNDS]: {
    type: RefundStatus.AWAITING_FUNDS,
    label: t(LABELS.STATUS.AWAITING_FUNDS),
  },
  [RefundStatus.INITIATED]: {
    type: RefundStatus.INITIATED,
    label: t(LABELS.STATUS.INITIATED),
  },
  [RefundStatus.PENDING]: {
    type: RefundStatus.PENDING,
    label: t(LABELS.STATUS.PENDING),
  },
  [RefundStatus.SUBMITTED]: {
    type: RefundStatus.SUBMITTED,
    label: t(LABELS.STATUS.SUBMITTED),
  },
  [RefundStatus.CONFIRMED]: {
    type: RefundStatus.CONFIRMED,
    label: t(LABELS.STATUS.CONFIRMED),
  },
  [RefundStatus.COMPLETED]: {
    type: RefundStatus.COMPLETED,
    label: t(LABELS.STATUS.COMPLETED),
  },
  [RefundStatus.CANCELED]: {
    type: RefundStatus.CANCELED,
    label: t(LABELS.STATUS.CANCELED),
  },
  [RefundStatus.FAILED]: {
    type: RefundStatus.FAILED,
    label: t(LABELS.STATUS.FAILED),
  },
};
